import type { IVideoPlayerProps } from '@components/M06-video-player/video-player';
import VideoPlayer from '@components/M06-video-player/video-player';
import React, { useState } from 'react';

export interface IListOfVideosProps {
    videos: IVideoPlayerProps[];
    defaultRows: number;
    header: string;
    loadMore: string;
}

export default function ListOfVideos({ header, videos, defaultRows = 2, loadMore }: IListOfVideosProps) {
    const initial = videos?.slice(0, defaultRows * 3) ?? [];
    const [shownVideos, setShownVideos] = useState<IVideoPlayerProps[]>(initial);

    if (!videos || videos.length === 0) {
        return null;
    }

    const showAllVideos = () => setShownVideos(videos);

    return (
        <section className={`fa-list-videos`}>
            <div className="fa-list-videos__content fa-block">
                <h2 className="fa-list-videos__content__title">{header}</h2>
                <ul className="fa-list-videos__content__list">
                    {shownVideos.map((video: IVideoPlayerProps, index: number) => (
                        <li key={index} className="fa-list-videos__content__list__item">
                            <VideoPlayer {...video} size="Medium" />
                        </li>
                    ))}
                </ul>
                {shownVideos.length < videos.length && (
                    <div className="fa-list-videos__action">
                        <button onClick={showAllVideos} className="fa-atom-button">
                            {loadMore}
                        </button>
                    </div>
                )}
            </div>
        </section>
    );
}
